// import { OrderTypeComponent } from '@app/modules/modals/order-type/order-type.component';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PdvService } from '../../services/pdv/pdv.service';
import { OrdersService } from '../../services/order/orders.service';
import { MenuService } from '@app/services/menu/menu.service';
import { MenuModalComponent } from '@app/modules/modals/menu-modal/menu-modal.component';
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    selector: 'best-offers',
    templateUrl: 'best-offers.component.html',
    styleUrls: ['best-offers.component.scss']
})
export class BestOffersComponent {
    bestSalesOffers: any[] = [];
    loadBestOffers: boolean[] = [];
    close = false;
    idPdv: string;
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    subscriptions2: Subscription[] = [];
    offerNbr: number;
    nbrOffersAuthorizedSite: number;
    loadOffers = true;
    orderProg;
    orderType;
    constructor(
        private pdvService: PdvService,
        private menuService: MenuService,
        private ordersService: OrdersService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private router: Router,
    ) {
        this.idPdv = this.pdvService.idPdv;
        let subs5 = this.ordersService.orderType.subscribe((orderType: number) => {
            this.orderType = orderType;
        });
        const subs1 = this.ordersService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        const subs2 = this.ordersService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.chosenOrderType > 0) {
                this.orderType = chosenOrderType;
            }
            this.getBestOffers();
        });
        const subs3 = this.ordersService.offerNbr.subscribe((offerNbr: any) => {
            this.offerNbr = offerNbr;
        });
        const subs4 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
            this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
        });
        this.subscriptions2.push(subs1, subs2, subs3, subs4,subs5);

    }
    
    getBestOffers() {
        this.menuService.getOffers(this.orderType, this.orderProg).toPromise().then(
            (offers: any[]) => {
                this.bestSalesOffers = offers;
                this.loadOffers = false;

            }
        )
    }

    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }

    ngOnDestroy() {
        this.unsubscribe2();
    }

    OpenMenuModal(i) {
        if (this.chosenOrderType > 0) {
            if (this.bestSalesOffers[i].offer == null || (this.bestSalesOffers[i].offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
                this.bsModalRef = this.modalService.show(MenuModalComponent, { class: 'modal-content3' });
                this.bsModalRef.content.menu = this.bestSalesOffers[i];
            } else {
                this.toastr.error('', 'Vous avez atteint le nombre d\'offre autorisée');
            }
        } else {
            this.router.navigate(["/modes"]);
        }
    }
}
